import React, { useState, useRef, useEffect } from "react";
import styles from "./Popover.module.css";

const Popover = ({ buttonContent, popoverContent, btnIcon }) => {
  const [isOpen, setIsOpen] = useState(false);
  const popoverRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popoverRef.current && !popoverRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const onPopoverToggle = (e) => {
    e.stopPropagation();
    setIsOpen(!isOpen);
  }

  return (
    <div className={styles.container} ref={popoverRef}>
      {buttonContent || (
        <button
          className={`${styles.loginButton} iconButton headerButtons`}
          onClick={onPopoverToggle}
        >
          {btnIcon}
        </button>
      )}

      {isOpen && (
        <div className={styles.popover}>
          {popoverContent}
        </div>
      )}
    </div>
  );
};

export default Popover;
